import React, { FunctionComponent, useState, useEffect } from 'react';
import { Presentation } from './presentation';
import type { RecruitmentShowApplicationsProps as Props } from './types';
import type { Story } from '../../../types/recruitmentShow';
import { showRecruitmentPageStories } from '../../../services/recruitments';

export const Component: FunctionComponent<Props> = (props) => {
  const [stories, setStories] = useState<Story[]>([]);
  useEffect(() => {
    const request = async () => {
      try {
        const response = await showRecruitmentPageStories(props.companyId);
        setStories(response.stories);
      } catch (error) {
        console.log(error);
      }
    };
    request();
  }, [props.companyId]);

  useEffect(() => {
    const $slider = $('.js-recruitment-applications')
    if (!$slider.hasClass('slick-initialized')) {
      $slider.slick({
        dots: false,
        arrows: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: false,
        centerPadding: '0',
        variableWidth: true,
        autoplay: false,
        prevArrow: '<div class="recruitment__show__company__slider--prev"></div>',
        nextArrow: '<div class="recruitment__show__company__slider--next"></div>',
        responsive: [
          {
            breakpoint: 929,
            settings: {
              arrows: false
            }
          }
        ]
      })
    }
  }, [stories])

  return (
    <Presentation
      {...props}
      applications={stories}
      recruitmentId={props.recruitmentId}
    />
  );
};
